import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import MarketInsight from '@app/model/market_insight/MarketInsight';
import { MarketInsightQueryKeys } from '@app/model/market_insight/service/MarketInsightQueryKeys';
import MarketInsightService from '@app/model/market_insight/service/MarketInsightService';

// A stable select: React Query keeps its result until the data changes, so a new render of the page does not give
// a new MarketInsight, and the effects that depend on it (Market Demand) do not run again.
const toMarketInsight = (data: MarketInsight | Record<string, any>) => {
	if (!data) {
		return undefined;
	}
	return data instanceof MarketInsight ? data : new MarketInsight(data as MarketInsight);
};

export function useMarketInsightQuery(
	companyHotelId: number,
	skipDays: number,
	options?: Omit<UseQueryOptions<MarketInsight, unknown, MarketInsight | undefined>, 'queryKey' | 'queryFn'>,
) {
	return useQuery({
		queryKey: MarketInsightQueryKeys.details(companyHotelId, skipDays),
		refetchOnWindowFocus: false,

		queryFn: () => MarketInsightService.findMarketInsight({ companyHotelId, skipDays }),
		...options,
		select: toMarketInsight,
	});
}